function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_Dutch_Icons_3rdWave"), /*#__PURE__*/React.createElement("path", {
  d: "M227.1 28.6L161.3 118c-3.6 4.9-5.6 10.8-5.6 16.9V223l-28 14.1V134.9c0-6.1-1.9-12-5.6-16.9L56.4 28.6h170.7M283.5 0H0l99.3 134.9v148.6l85-42.9V134.9L283.5 0z"
})));